import { render, staticRenderFns } from "./PremiumModal.vue?vue&type=template&id=6d6d4361&scoped=true"
import script from "./PremiumModal.vue?vue&type=script&lang=js"
export * from "./PremiumModal.vue?vue&type=script&lang=js"
import style0 from "./PremiumModal.vue?vue&type=style&index=0&id=6d6d4361&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6d4361",
  null
  
)

export default component.exports